export enum TimeRange {
  LAST_HOUR = "LAST_HOUR",
  LAST_DAY = "LAST_DAY",
  LAST_WEEK = "LAST_WEEK",
  LAST_MONTH = "LAST_MONTH",
}

// For iterating over TimeRange
// as Typescript complains when iterating over an enum
export const TIME_RANGES = ["LAST_HOUR", "LAST_DAY", "LAST_WEEK", "LAST_MONTH"];
